import {BooleanApiData, DocumentBaseRequest, DocumentDTO} from '../../api/data-contracts'
import {Api_Document_AddDownloadRecord} from '../../apiClient/apiClient'
import {postRequestAsync} from '../../redux/commonSlice'
import {useDispatch} from 'react-redux'
import {loadDocuments, loadFolders} from '../../redux/documentSlice'

function DocumentOpenButton(props: {file: DocumentDTO}) {
  const dispatch = useDispatch()
  async function addDownloadRecord(documentId: string) {
    const body: DocumentBaseRequest = {
      documentId: documentId,
    }
    await dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Document_AddDownloadRecord,
        body: body,
      })
    )
      .unwrap()
      .then(async (response: BooleanApiData) => {
        await dispatch<any>(loadFolders())
        await dispatch<any>(loadDocuments())
      })
  }

  return (
    <a
      type='button'
      href={props.file.uri ?? ''}
      target={'_blank'}
      onClick={() => {
        addDownloadRecord(props.file.guid ?? '')
      }}
      className='btn btn-sm btn-icon btn-light btn-active-light-primary' rel="noreferrer"
    >
      <i className='fa-solid fa-arrow-up-right-from-square'></i>
    </a>
  )
}

export default DocumentOpenButton
